import { keaReducer } from 'kea'
const keaScenesReducer = keaReducer('scenes')
export default keaScenesReducer;


// WEBPACK FOOTER //
// ./src/keaReducer.js